// NOTE: This has to be all lowercase to work with remark. If you pass in
// `entityReference` you'll still get `entityreference` coming out, so it's best
// to keep it consistent.
export const entityReferenceTagName = `entityreference`;

// Format the agent emits to reference a tool result inline: `toolCallId:toolType:[[index]]`
// (e.g. `call_abc123:searchEvents:[[3]]`). The `/g` flag is required by both consumers
// (`String.prototype.matchAll` in tracking and `findAndReplace` in the remark plugin).
export const entityReferenceRegex = /([\w-]+):([\w]+):\[\[(\d+)\]\]/g;
